import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';

const PAGE_TITLES: Record<string, string> = {
  '/dashboard': 'Dashboard',
  '/alumnos': 'Gestión de Alumnos',
  '/familias': 'Familias',
  '/monitores': 'Gestión de Entrenadores',
  '/sesiones': 'Grupos',
  '/agenda': 'Sesiones',
  '/negocio': 'Negocio',
  '/gestion': 'Gestión',
  '/analitica': 'Analítica',
  '/clases-especiales': 'Clases Especiales',
  '/bonos': 'Bonos y Créditos',
  '/tienda': 'Tienda',
  '/pedidos': 'Pedidos',
  '/comunicaciones': 'Comunicaciones',
  '/evaluaciones': 'Evaluaciones',
  '/valoraciones': 'Valoraciones de Sesiones',
  '/estadisticas': 'Estadísticas del Negocio',
  '/configuracion': 'Configuración',
};

export default function AdminLayout() {
  const location = useLocation();
  const basePath = '/' + location.pathname.split('/')[1];
  const title = PAGE_TITLES[basePath] ?? 'VERTEX Performance';

  return (
    <div className="flex min-h-screen bg-bg-primary" data-testid="admin-layout">
      <Sidebar />
      <div className="flex-1 ml-64 flex flex-col">
        <Header title={title} />
        <main className="mt-16 p-8 flex-1">
          <Outlet />
        </main>
        <footer className="px-8 py-4 text-center text-text-secondary text-xs font-inter opacity-60 tracking-wider">
          by Cognix Labs
        </footer>
      </div>
    </div>
  );
}
